export class ToggleComponent {
    constructor() {
        this.elements = document.querySelectorAll('[data-panvel-toggle]');
        this.activeClass = 'actived';
        this.initEvents();
    }
    initEvents() {
        if (this.elements) {
            Array.prototype.forEach.call(this.elements, el => {
                el.addEventListener('click', e => {
                    e.preventDefault();
                    const attr = el.getAttribute("data-panvel-target");
                    const target  = document.querySelector(`#${attr}`);

                    el.classList.toggle(this.activeClass)

                    if(target) {
                        target.classList.toggle(this.activeClass)
                    }
                })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/toggle/toggle.component.js